import { render, staticRenderFns } from "./MobileOffersBiz.vue?vue&type=template&id=5d61d5ae"
import script from "./MobileOffersBiz.vue?vue&type=script&lang=js"
export * from "./MobileOffersBiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports